import { Field } from "../field";
import { Input } from "./input";

export function TimeRange({
  idStart,
  startLabel,
  start,
  startErrors,
  onStartChange,
  idEnd,
  endLabel,
  end,
  endErrors,
  onEndChange,
}: {
  idStart: string;
  idEnd: string;
  start: string;
  end: string;
  startLabel: string;
  endLabel: string;
  startErrors?: string[] | undefined;
  endErrors?: string[] | undefined;
  onStartChange: (value: string) => void;
  onEndChange: (value: string) => void;
}) {
  return (
    <div className="flex gap-4 items-center">
      <Field id={idStart} label={startLabel} errors={startErrors}>
        <Input
          className="w-full"
          id={idStart}
          value={start}
          type="time"
          onChange={(e) => {
            onStartChange(e.target.value);
          }}
        />
      </Field>
      <Field id={idEnd} label={endLabel} errors={endErrors}>
        <Input
          className="w-full"
          id={idEnd}
          value={end}
          type="time"
          onChange={(e) => {
            onEndChange(e.target.value);
          }}
        />
      </Field>
    </div>
  );
}
